import { render } from "./ComponentA.vue?vue&type=template&id=3c3c0eb6"
import script from "./ComponentA.vue?vue&type=script&lang=js"
export * from "./ComponentA.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rominpatel/Documents/sites/bluegempartners/wp-content/themes/everge/packages/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__